
<report-filter
showCostCenters='true'
showFacilities='true'
showPeriodEndDateSelection='true'
showShiftBlocks='true'
showViews='true'
defaultPayPeriodsBack=1
defaultView='Date'
reportType='inpatient'
[(defaultFilter)]="filters"
(filterUpdated)="filterUpdated($event)"
[(views)]="views">
</report-filter>

<smt-performancereport
[filtersUpdated]='filterEventsSubject.asObservable()'
(performanceDataUpdated)='performanceDataUpdated($event)'
[(reportFilters)]='filters'>
</smt-performancereport>

<report-export-button
[reportFilters]="filters"
[exportUrl]="'Performance/GetInpatientPerformanceExportData'"
[fileName]="'Inpatient_Performance_Report'"
[filtersUpdated]='filterEventsSubject.asObservable()'>
</report-export-button>

<table class="condensed" role="list" *ngIf="performanceData.gridInformation">
<colgroup>
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="large-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
</colgroup>
<thead>
  <th align="left">Date</th>
  <th align="left">UOS</th>  
  <th align="left">Average Starting Census</th>
  <th align="left">WHPUOS</th>
  <th align="left">Target Worked Hours</th>
  <th align="left">Worked Hours</th>
  <th align="left">Hours Variance</th>
  <th align="left" *ngIf="hideMidnightVariance">Midnight Variance</th>
  <th align="left">Churn Rate</th>
  <th align="left">Productivity Percent</th>
</thead>
<tr *ngFor="let item of performanceData.gridInformation">
  <td>{{item.fieldName}}</td>
  <td>{{formatValue(item.uos)}}</td>
  <td>{{formatValue(item.startingCensus)}}</td>
  <td>{{item.whpuos ? formatValue(item.whpuos) : '-'}}</td>
  <td>{{formatValue(item.targetWorkedHours)}}</td>
  <td>{{formatValue(item.workedHours)}}</td>
  <td>{{formatValue(item.variance)}}</td>
  <td *ngIf="hideMidnightVariance">{{formatValue(item.midnightVariance)}}</td>
  <td>{{formatValue(item.dailyChurnRate, 0)}}%</td>
  <td>{{item.productivityPercent ? formatValue(item.productivityPercent, 0) + '%' : '-'}}</td>
</tr>
</table>
